import React from 'react';
import { IMPORT_CONDITIONS_URL } from '../lib/importConditions';

export const ImportTitreNotice = () => (
  <aside
    role="note"
    data-testid="import-favn-update-notice"
    className="mb-5 rounded-lg border-l-4 border-orange-600 bg-orange-50 p-4"
  >
    <p
      data-testid="import-favn-update-text"
      className="text-sm sm:text-base leading-relaxed font-medium text-orange-800"
    >
      <strong>As of October 1st, 2026, rabies titre testing is only required for certain jurisdictions.</strong>{' '}
      Please refer to the{' '}
      <a
        href={IMPORT_CONDITIONS_URL}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="import-favn-conditions-link"
        className="underline underline-offset-2 hover:text-orange-950 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-orange-800"
      >
        importation conditions
      </a>{' '}
      or contact{' '}
      <a
        href="mailto:pawsome.ky@gmail.com"
        data-testid="import-favn-pawsome-contact-link"
        className="underline underline-offset-2 hover:text-orange-950 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-orange-800"
      >
        Pawsome Ventures
      </a>{' '}
      if you’re unsure whether your pet requires testing.
    </p>
  </aside>
);